<template>
  <div>
    <a-card
      class="column-card box-shadow"
      :bordered="false"
      style="min-height: 400px"
    >
      <a-tabs tab-position="left" :default-active-key="currentTab" v-model="currentTab" @change="getCmsList">
        <a-tab-pane key="1" tab="文件通知">
          <a-list :dataSource="cmsDataSource">
            <a-list-item
              class="cms-item"
              slot="renderItem"
              slot-scope="item"
              @click="toCmsDetail(item)"
            >
              <span class="cms-title">{{ item.cmsTitile }}</span>
              <span class="cms-time">{{ item.createTime }}</span>
            </a-list-item>
          </a-list>
        </a-tab-pane>
        <a-tab-pane key="2" tab="新闻报道">
          <a-list :dataSource="cmsDataSource">
            <a-list-item
              class="cms-item"
              slot="renderItem"
              slot-scope="item"
              @click="toCmsDetail(item)"
            >
              <span class="cms-title">{{ item.cmsTitile }}</span>
              <span class="cms-time">{{ item.createTime }}</span>
            </a-list-item>
          </a-list>
        </a-tab-pane>
        <a-tab-pane key="3" tab="地方动态">
          <a-list :dataSource="cmsDataSource">
            <a-list-item
              class="cms-item"
              slot="renderItem"
              slot-scope="item"
              @click="toCmsDetail(item)"
            >
              <span class="cms-title">{{ item.cmsTitile }}</span>
              <span class="cms-time">{{ item.createTime }}</span>
            </a-list-item>
          </a-list>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>

<script>
import { getAction } from "@/api/manage";

export default {
  data() {
    return {
      cmsDataSource: [],
      currentTab: '1'
    };
  },
  created() {
    if (this.$route.query.type) {
      this.currentTab = this.$route.query.type;
    }
    this.getCmsList(this.currentTab);
  },
  watch:{
    $route(v){
      if (this.$route.query.type) {
        this.currentTab = this.$route.query.type;
      }else{
        this.currentTab = "1"
      }
      this.currentTab = this.$route.query.type
      this.getCmsList(this.$route.query.type);
    }
  },
  methods: {
    getCmsList(type) {
      this.cmsType = type;
      this.cmsDataSource = [];
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        cmsType: type,
        pageSize: 10,
      }).then((res) => {
        if (res.success) {
          this.cmsDataSource = res.result.records;
        }
      });
    },
    toCmsDetail(item) {
      let route = this.$router.resolve({
        path: "/cms/detail",
        query: {
          id: item.id,
        },
      });
      window.open(route.href, '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
.cms-item{
  cursor: pointer;
}
</style>